import { createContext, useContext, useState, useEffect } from "react";

const CurrencyContext = createContext();

export const CURRENCIES = {
  USD: { symbol: "$", code: "USD", name: "US Dollar", locale: "en-US" },
  INR: { symbol: "₹", code: "INR", name: "Indian Rupee", locale: "en-IN" }
};

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState(() => {
    const saved = localStorage.getItem("preferred_currency");
    return saved || "USD";
  });

  useEffect(() => {
    localStorage.setItem("preferred_currency", currency);
  }, [currency]);

  const formatAmount = (amount, forceCurrency = null) => {
    const curr = forceCurrency || currency;
    const config = CURRENCIES[curr] || CURRENCIES.USD;
    
    return new Intl.NumberFormat(config.locale, {
      style: "currency",
      currency: config.code,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(amount || 0);
  };

  const formatNumber = (amount) => {
    const config = CURRENCIES[currency] || CURRENCIES.USD;
    return new Intl.NumberFormat(config.locale).format(amount || 0);
  };

  const value = {
    currency,
    setCurrency,
    currencyConfig: CURRENCIES[currency] || CURRENCIES.USD,
    formatAmount,
    formatNumber,
    currencies: CURRENCIES
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error("useCurrency must be used within a CurrencyProvider");
  }
  return context;
}
